<div
  #terminalBlock
  *appHasAccess="['TERMINALS_VIEW']"
  class="terminal">
  <div class="page-head">
    <div class="page-head__left"></div>
    <div class="page-head__right">
      <app-filter-button
        [isOpenFilter]="isOpenFilter"
        (toggleFilterEvent)="toggleFilter($event)"
        [isEnableUpload]="false"
        (uploadEvent)="upload()">
      </app-filter-button>
    </div>
  </div>

  <div class="payment-page__filer">
    <app-filter-block
      [additional]="filterAdditional"
      [(isOpenFilter)]="isOpenFilter">
      <app-terminal-page-filter
        [filterBanks]="filterBanks"
        [filterStatuses]="filterStatuses">
      </app-terminal-page-filter>
    </app-filter-block>
  </div>

  <div class="terminal__body">
    <div
      #tableBlock
      (scroll)="onScroll($event)"
      class="table">
      <div class="table-head">
        <div class="table__row">
          <div
            (click)="sortColumn('IS_BLOCKED')"
            class="column sortable table__row-head">
            <span
              [class.sorted]="sortColumnData?.field === 'IS_BLOCKED'"
              [class.asc]="sortColumnData?.order === 'ASC'"
              [class.desc]="sortColumnData?.order === 'DESC'"
              class="sortable__content">
              {{ "TERMINAL_PAGE.STATUS" | translate }}
            </span>
          </div>
          <div
            (click)="sortColumn('BANK_TERMINAL_ID')"
            class="column sortable table__row-head">
            <span
              [class.sorted]="sortColumnData?.field === 'BANK_TERMINAL_ID'"
              [class.asc]="sortColumnData?.order === 'ASC'"
              [class.desc]="sortColumnData?.order === 'DESC'"
              class="sortable__content">
              {{ "TERMINAL_PAGE.ID_TERMINAL_BSL" | translate }}
            </span>
          </div>

          <div class="column table__row-head">
            <span>
              {{ "TERMINAL_PAGE.TYPE" | translate }}
            </span>
          </div>

          <div
            (click)="sortColumn('BANK_NAME')"
            class="column sortable table__row-head">
            <span
              [class.sorted]="sortColumnData?.field === 'BANK_NAME'"
              [class.asc]="sortColumnData?.order === 'ASC'"
              [class.desc]="sortColumnData?.order === 'DESC'"
              class="sortable__content">
              {{ "TERMINAL_PAGE.BSL" | translate }}
            </span>
          </div>
          <div
            (click)="sortColumn('ID')"
            class="column sortable table__row-head">
            <span
              [class.sorted]="sortColumnData?.field === 'ID'"
              [class.asc]="sortColumnData?.order === 'ASC'"
              [class.desc]="sortColumnData?.order === 'DESC'"
              class="sortable__content">
              {{ "TERMINAL_PAGE.ID_MERCHANT" | translate }}
            </span>
          </div>
          <div
            (click)="sortColumn('TERMINAL_NAME')"
            class="column sortable table__row-head">
            <span
              [class.sorted]="sortColumnData?.field === 'TERMINAL_NAME'"
              [class.asc]="sortColumnData?.order === 'ASC'"
              [class.desc]="sortColumnData?.order === 'DESC'"
              class="sortable__content">
              {{ "TERMINAL_PAGE.TERMINAL" | translate }}
            </span>
          </div>
        </div>
      </div>
      <div
        #tableBody
        class="table-body">
        <div
          *ngFor="let item of terminalList"
          (dblclick)="openPaymentForTerminal(item.bank_terminal_id)"
          class="table__row">
          <div class="column table__row-data">
            <span class="mobile">{{ item.name }}</span>
            <img
              *ngIf="item.is_blocked"
              src="assets/img/blocked-state.svg "
              alt="Unblock" />
            <img
              *ngIf="!item.is_blocked"
              src="assets/img/active-state.svg "
              alt="Active" />
          </div>
          <div class="column table__row-data">
            <span
              *ngIf="item.bank_terminal_id"
              class="mobile">
              {{ "TERMINAL_PAGE.ID_TERMINAL_BSL" | translate }}:
            </span>
            {{ item.bank_terminal_id }}
          </div>
          <div class="column table__row-data">
            <span class="mobile">{{ "TERMINAL_PAGE.TYPE" | translate }} :</span>
            <ng-container *ngIf="item.is_aft && item.is_for_p2p">
              {{ "TERMINAL_PAGE.P2P_AFT" | translate }}
            </ng-container>
            <ng-container *ngIf="item.is_aft && !item.is_for_p2p">
              {{ "TERMINAL_PAGE.AFT" | translate }}
            </ng-container>
            <ng-container *ngIf="item.is_for_p2p && !item.is_aft">
              {{ "TERMINAL_PAGE.P2P" | translate }}
            </ng-container>
            <ng-container *ngIf="!item.is_for_p2p && !item.is_aft">
              {{ "TERMINAL_PAGE.IA" | translate }}
            </ng-container>
          </div>
          <div class="column table__row-data">
            <span class="mobile"> {{ "TERMINAL_PAGE.BSL" | translate }}: </span>
            {{ item.bank_name }}
          </div>
          <div class="column table__row-data">
            <span class="mobile"> {{ "TERMINAL_PAGE.ID_MERCHANT" | translate }}: </span>
            {{ item.bank_agent_id }}
          </div>
          <div class="column table__row-data">
            {{ item.name }}
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
